import "./index.scss"
export function Paragraph(props) {
	const {content, className} = props;
	if (!content) {
		return null;
	}
	return <p className={`dp__paragraph ${className}`}>{content}</p>;
}